module.exports = __webpack_public_path__ + "img/scBanner.ff135db9.jpg";